/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import React from 'react';
import { Box, VStack } from 'chakra-v3';
import { Text } from '../../components/Text';

interface PromptCardProps {
  queries: string;
  fontSize?: { base: string; sm: string; md: string; lg: string };
  className?: string;
  style?: React.CSSProperties;
}

const DEFAULT_FONT_SIZE = { base: '14px', sm: '15px', md: '16px', lg: '16px' };

export const PromptCard: React.FC<PromptCardProps> = ({
  queries,
  fontSize = DEFAULT_FONT_SIZE,
  className = '',
  style = {},
}) => {
  return (
    <Box
      style={style}
      className={className}
      bg="#f9f9f9"
      border="1px solid"
      borderColor="rgba(10, 49, 60, 0.25)"
      borderRadius="4px"
      p={{ base: 4, sm: 5, md: 10, lg: 10 }}
      display="flex"
      flexDirection="column"
      gap={{ base: 4, sm: 6, md: '60px', lg: '60px' }}
      boxShadow="4px 8px 12px 0px rgba(0, 0, 0, 0.09)"
      w="full"
      h="full"
    >
      {/* Query Section */}
      <VStack align="start" gap={{ base: '8px', sm: '12px', md: '16px' }}>
        <Text
          fontFamily="heading"
          fontSize={{ base: '16px', sm: '18px', md: '20px', lg: '20px' }}
          fontWeight="300"
          lineHeight="normal"
          letterSpacing="-1px"
          color="#0a313c"
        >
          Query
        </Text>
        <Text
          fontFamily="body"
          fontSize={fontSize}
          fontWeight="normal"
          lineHeight="1.6"
          color="#1a1a1a"
          whiteSpace="pre-wrap"
        >
          {queries}
        </Text>
      </VStack>
    </Box>
  );
};
